import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NewsListComponent } from 'src/app/modules/news/components/news-list/news-list.component';
import { NewsComponent } from 'src/app/modules/news/components/news/news.component';
import { MaterialModule } from '../app-material.module';
import { SharedModule } from '../shared/shared.module';
import { NewsAuthorizationHistoryComponent } from './components/news-details/news-authorization-history/news-authorization-history.component';
import { NewsDetailsComponent } from './components/news-details/news-details.component';
import { NewsAuthorizationStatusFilterComponent } from './components/news-details/news-engagement-list/news-authorization-status-filter/news-authorization-status-filter.component';
import { NewsEngagementItemComponent } from './components/news-details/news-engagement-list/news-engagement-item/news-engagement-item.component';
import { NewsEngagementListComponent } from './components/news-details/news-engagement-list/news-engagement-list.component';
import { NewsInfoComponent } from './components/news-details/news-info/news-info.component';
import { QuillModule } from 'ngx-quill';

@NgModule({
  declarations: [
    NewsListComponent,
    NewsComponent,
    NewsInfoComponent,
    NewsAuthorizationStatusFilterComponent,
    NewsAuthorizationHistoryComponent,
    NewsDetailsComponent,
    NewsEngagementItemComponent,
    NewsEngagementListComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    InfiniteScrollModule,
    QuillModule.forRoot(),
  ],
  exports: [NewsListComponent, NewsComponent],
})
export class NewsModule {}
